import React from "react";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";

const notifications = [
  {
    id: 1,
    name: "marija_s",
    text: "is new live right now!",
    status: "live",
    avatarUrl: "images/marija_1.png",
  },
  {
    id: 2,
    name: "marija_s",
    text: "post video!",
    avatarUrl: "images/marija_1.png",
  },
  {
    id: 3,
    name: "marija_s",
    text: "is live right now!",
    status: "ended",
    avatarUrl: "images/marija_1.png",
  },
  {
    id: 4,
    name: "nikola_93",
    text: "commented on the post",
    time: "13:34",
  },
  {
    id: 5,
    name: "jelena.stankovic",
    text: "posted something new.",
    time: "1d",
  },
  {
    id: 6,
    name: "nikola_93",
    text: "is live right now.",
    status: "ended",
    time: "1d",
  },
  {
    id: 7,
    name: "jelena.stankovic",
    text: "posted something new.",
    time: "2w",
  },
];

export default function Notifications3() {
  const navigate = useNavigate();
  return (
    <div className="notif-screen">
      <div className="notif-window">
        <header className="notif-header">
          <span className="notif-header-title">Notifications</span>
        </header>

        <div className="notif-list">
          {notifications.map((n) => (
            <div key={n.id} className="notif-item">
              <div className="notif-avatar-wrapper">
                {n.avatarUrl ? (
                  <img
                    src={n.avatarUrl}
                    alt={n.name}
                    className="notif-avatar-image"
                  />
                ) : (
                  <div className="notif-avatar-circle" />
                )}
              </div>

              <div className="notif-content">
                <div className="notif-name-row">
                  <span className="notif-name">{n.name}</span>
                </div>
                <div className="notif-text">{n.text}</div>
              </div>

              <div className="notif-right">
                {n.status === "live" && (
                  <button
                    className="notif-pill notif-pill--live"
                    onClick={() => navigate("/live2")}
                  >
                    Join Live
                  </button>
                )}

                {n.status === "ended" && (
                  <button className="notif-pill notif-pill--ended">
                    Live Ended
                  </button>
                )}

                {!n.status && <div className="notif-thumb" />}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer page="reels" navigateTo="/notifikacije3" />
    </div>
  );
}
